export function ArrayToObject(arr, key = 'id') {
  let auxObj = {};
  arr.forEach(element => {
    auxObj[element[key]] = element;
  });
  return auxObj;
}

export function arrayDifference([...arr1] = [], [...arr2] = []) {
  return arr1.filter(element => !arr2.includes(element));
}

function areArraysEqual(a, b) {
  if (a.length !== b.length) return false;

  const visited = new Array(b.length).fill(false);

  return a.every(itemA => {
    for (let i = 0; i < b.length; i++) {
      if (!visited[i] && isDataEqual(itemA, b[i])) {
        visited[i] = true;
        return true;
      }
    }
    return false;
  });
}

export function isDataEqual(data1, data2) {
  if (data1 === data2) return true;

  if (typeof data1 !== typeof data2) return false;

  if (typeof data1 === 'string') {
    return data1.trim() === data2.trim();
  }

  if (typeof data1 === 'number' || typeof data1 === 'boolean') {
    return data1 === data2;
  }

  if (Array.isArray(data1) && Array.isArray(data2)) {
    return areArraysEqual(data1, data2);
  }

  if (typeof data1 === 'object' && data1 !== null && data2 !== null) {
    const keys1 = Object.keys(data1);
    const keys2 = Object.keys(data2);

    if (keys1.length !== keys2.length) return false;

    return keys1.every(
      key => keys2.includes(key) && isDataEqual(data1[key], data2[key])
    );
  }

  return false;
}
